import { WMeasurementUnits } from "../types";

type UnitTranslation = {
    single: string,
    multiple: string
}

export const unitsi18n : {[lang: string]: {[unit: string]: UnitTranslation}} = {
    en: {
        [WMeasurementUnits.Times]: {
            single : "time" ,
            multiple: "times"
        }
    },
    he: {
        [WMeasurementUnits.Seconds] : {
          single : "שניה" ,
          multiple: "שניות"
        },
        [WMeasurementUnits.Minutes] : {
            single : "דקה" ,
            multiple: "דקות"
        },
        [WMeasurementUnits.Hours] : {
            single : "שעה" ,
            multiple: "שעות"
        },
        [WMeasurementUnits.Days] : {
            single : "יום" ,
            multiple: "ימים"
        },
        [WMeasurementUnits.Weeks] : {
            single : "שבוע" ,
            multiple: "שבועות"
        },
        [WMeasurementUnits.Months] : {
            single : "חודש" ,
            multiple: "חודשים"
        },
        [WMeasurementUnits.Years] : {
            single : "שנה" ,
            multiple: "שנים"
        },
        [WMeasurementUnits.Times]: {
            single : "פעם" ,
            multiple: "פעמים"
        }
    }
}
